import type { FC } from 'react';

import { useNavigate } from 'react-router';

import type { Register, RegisterDialog, RegisterDialogData } from '../../../types/helsenorge.helseregistre.internalapi.entities.entities';
import { RegisterDialogType } from '../../../types/helsenorge.helseregistre.internalapi.entities.enums';
import type { HNHelseregistreJS } from '../../../types/Resources';

import Button from '@helsenorge/designsystem-react/components/Button';
import Icon from '@helsenorge/designsystem-react/components/Icon';
import Envelope from '@helsenorge/designsystem-react/components/Icons/Envelope';
import Spacer from '@helsenorge/designsystem-react/components/Spacer';

import { getRegisterDialogData, SUBMIT_MESSAGE_SET_CONTROLHASH, SUBMIT_MESSAGE_SET_REGISTER } from './register-melding';
import { getRegisterDialogTypeForMeldeFeil } from './utils';
import { useAppDispatch } from '../../store/hooks';

export interface Props {
  register: Register;
  resources: HNHelseregistreJS;
  dialogTyper: RegisterDialog | null;
}

const RegisterMeldingerComponent: FC<Props> = ({ register, resources, dialogTyper }) => {
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const showMeldeFeilMessageSubmitClick = (): void => {
    dispatch(SUBMIT_MESSAGE_SET_REGISTER(register));
    const meldeFeilDialogType: RegisterDialogData | undefined | null = getRegisterDialogTypeForMeldeFeil(dialogTyper);
    dispatch(SUBMIT_MESSAGE_SET_CONTROLHASH(meldeFeilDialogType ? meldeFeilDialogType.controlHash : null));
    navigate('/melde-feil');
  };

  const hasMeldeFeil = !!dialogTyper && !!getRegisterDialogData(dialogTyper, RegisterDialogType.RegisterMeldeFeil);

  return hasMeldeFeil ? (
    <>
      <Spacer size="xs" />
      <Button variant="outline" onClick={showMeldeFeilMessageSubmitClick}>
        <Icon svgIcon={Envelope} />
        {resources.meldeFeilLink}
      </Button>
    </>
  ) : null;
};

export default RegisterMeldingerComponent;
